export function createRoutes() {
  return [
    {
      path: 'playbacks',
      component: () => import(/* webpackChunkName: "playbackInsight" */ '@/playback/PlaybackInsightChrome.vue'),
      children: [
        {
          path: '/',
          name: 'playbackInsightList',
          component: () => import(/* webpackChunkName: "playbackInsightList" */ '@/playback/PlaybackInsightList.vue'),
        },
        {
          path: ':playbackId',
          name: 'playbackInsightItemDetail',
          component: () => import(/* webpackChunkName: "playbackInsightItemDetail" */ '@/playback/playbackInsightItemDetail.vue'),
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
